// removed by extract-text-webpack-plugin
module.exports = {"container":"medium-share-tooltip__container__2jwN-","tooltip":"medium-share-tooltip__tooltip__2aLHx","icon-container":"medium-share-tooltip__icon-container__SU9TI","icon":"medium-share-tooltip__icon__6v3YD","icon-label":"medium-share-tooltip__icon-label__-5TLH"};


//////////////////
// WEBPACK FOOTER
// ./src/components/media/medium-share-tooltip.scss
// module id = 1441
// module chunks = 1